module.exports = __webpack_public_path__ + "static/media/bancolombia-icon-faq-005.993e4807.svg";